// The API serialises ErrorCode as the enum name ("CancellationPolicyNotAccepted"), so codes are
// matched by name. Numbers are also accepted, for responses written before enums became strings.
const ERROR_CODE_NUMBERS = {
  StorePrepaymentRequiresOnlinePayments: 4038,
  CustomerAppointmentCancelTooLate: 5016,
  PaidAppointmentDeleteNotAllowed: 5025,
  CancellationPolicyNotAccepted: 5026,
  AppointmentPrepaymentRequired: 5027,
  AppointmentProductsPaidOnline: 5028,
  ServicePrepaymentConfigurationInvalid: 6021,
  ServiceDepositBelowProcessingFee: 6022,
  ServicePrepaymentRequiresOnlinePayments: 6023,
  ProductNotSellable: 6019,
  InsufficientStock: 6044,
  StockUnitChangeNotAllowed: 6045,
  StockPurchaseNotFound: 6046,
  StockPurchaseAlreadyVoided: 6047,
  SupplierNotFound: 6048,
  SupplierArchived: 6049,
  ExpenseNotFound: 6050,
  ExpenseReadOnly: 6051,
  ExpenseRecurrenceInvalid: 6052,
  ExpenseEditScopeInvalid: 6053,
  ServiceRecipeInvalid: 6054,
  FreeServiceConfigurationInvalid: 6057,
  FreeServiceUsageLimitExceeded: 6058,
  ServiceNotVisibleToCustomers: 6059,
};

const NAMES_BY_NUMBER = Object.fromEntries(
  Object.entries(ERROR_CODE_NUMBERS).map(([name, number]) => [number, name]),
);

/** The API error code name of a failed request, or null. */
export const getApiErrorCode = (error) => {
  const code = error?.response?.data?.code ?? error?.response?.data?.Code;
  if (code === undefined || code === null || code === '') {
    return null;
  }

  const asNumber = Number(code);
  if (Number.isFinite(asNumber)) {
    return NAMES_BY_NUMBER[asNumber] ?? String(code);
  }

  return String(code);
};

export const isApiErrorCode = (error, name) => getApiErrorCode(error) === name;
